import React from 'react';
import './SingleSchedule.scss';
import { addMinutes, addHours, format } from 'date-fns';

const SingleSchedule = ({ }) => {
  const selectedSchedule = {
    scheduleName: "Morning Irrigation",
    nextStartTime: "2025-05-01T07:30", // ISO 8601 format
    sequence: [
      {
        zone: "Zone A",
        zoneId: "zone-1",
        duration: { hours: 2, minutes: 30 }
      },
      {
        zone: "Zone B",
        zoneId: "zone-2",
        duration: { hours: 1, minutes: 45 }
      },
      {
        zone: "Zone C",
        zoneId: "zone-3",
        duration: { hours: 1, minutes: 0 }
      }
    ]
  };

  const field = {
    name: "North Field",
    zones: [
      {
        id: "zone-1",
        name: "Zone A",
        hasWaterSensor: true,
        pipes: [
          { pipeNumber: 1, pipeSide: "Left" },
          { pipeNumber: 2, pipeSide: "Right" }
        ]
      },
      {
        id: "zone-2",
        name: "Zone B",
        hasWaterSensor: false,
        pipes: [
          { pipeNumber: 3, pipeSide: "Left" }
        ]
      },
      {
        id: "zone-3",
        name: "Zone C",
        hasWaterSensor: true,
        pipes: [
          { pipeNumber: 4, pipeSide: "Left" },
          { pipeNumber: 5, pipeSide: "Right" },
          { pipeNumber: 6, pipeSide: "Right" }
        ]
      }
    ]
  };

  const shouldDisplayTimeColumn = selectedSchedule.nextStartTime !== '';

  function parseDateTime(dateTimeString) {
    const [datePart, timePart] = dateTimeString.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hour, minute] = timePart.split(':').map(Number);
    return new Date(year, month - 1, day, hour, minute);
  }

  let startTime = parseDateTime(selectedSchedule.nextStartTime);

  function currentTime(prevHours, prevMinutes) {
    if (prevHours) startTime = addHours(startTime, prevHours);
    if (prevMinutes) startTime = addMinutes(startTime, prevMinutes);
  }

  return (
    <div className='SingleSchedule'>
      <h1 className='schedule-name'>{selectedSchedule.scheduleName}</h1>
      <div className='start-and-table-container'>
        <div className='start-time-container'>
          {shouldDisplayTimeColumn && (
            <h3>Next Scheduled Start Time: {format(startTime, 'MM/dd/yyyy h:mm a')}</h3>
          )}
          <button className='manual-start'>Manual Start</button>
        </div>
        <table className='schedule-table'>
          <thead>
            <tr>
              {shouldDisplayTimeColumn && <th className='table-header'>Start Time</th>}
              <th className='table-header'>Duration(Hours/Min)</th>
              <th className='table-header'>Zone</th>
              <th className='table-header'>Pipes</th>
              <th className='table-header'>Water Sensor</th>
            </tr>
          </thead>
          <tbody>
            {selectedSchedule.sequence.map((item, index) => {
              const matchingZone = field.zones.find((zone) => zone.id === item.zoneId);

              const pipeList = matchingZone?.pipes.map((pipe, pipeIndex) => (
                <span key={pipeIndex} className='pipe'>
                  Pipe {pipe.pipeNumber} ({pipe.pipeSide})
                </span>
              ));

              const hasWaterSensor = matchingZone?.hasWaterSensor ? 'Yes' : 'No';

              const rowInfo = (
                <tr key={index} className='table-row'>
                  {shouldDisplayTimeColumn && (
                    <td className='time'>{format(startTime, 'h:mm a')}</td>
                  )}
                  <td className='duration'>{item.duration.hours}:{item.duration.minutes}</td>
                  <td className='zone'>{item.zone}</td>
                  <td className='pipe-list'>{pipeList}</td>
                  <td className='sensor'>{hasWaterSensor}</td>
                </tr>
              );

              currentTime(item.duration.hours, item.duration.minutes);
              return rowInfo;
            })}
          </tbody>
        </table>
      </div>
      <button className='manual-progress'>Progress to next zone</button>
    </div>
  );
};

export default SingleSchedule;